import Badge from '@bbkPricingPage/components/badge/badge';
import {
  BadgeType,
  type Badge as BadgeObjectType,
} from '@bbkPricingPage/types/pricing-table-types';

export const PriceCardBadge = ({
  id,
  badge,
}: {
  id: string;
  badge?: BadgeObjectType;
}) => {
  return (
    badge &&
    badge.type !== BadgeType.none &&
    badge.text && (
      <div
        id={`item-badge-${id}`}
        className="tw-absolute tw-top-0 tw-flex tw-h-9 tw-w-full tw-items-end tw-justify-center tw-rounded-t-[inherit] tw-leading-none"
      >
        <Badge variant={badge.type}>
          <div className="tw-text-sm tw-font-semibold tw-uppercase">
            {badge.text ?? ''}
          </div>
        </Badge>
      </div>
    )
  );
};
